import { render } from "./CommonProperty.vue?vue&type=template&id=2e9a9c16"
import script from "./CommonProperty.vue?vue&type=script&lang=js"
export * from "./CommonProperty.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/workflow/components/propertySetting/CommonProperty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e9a9c16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e9a9c16', __exports__)) {
    console.log('reload')
    api.reload('2e9a9c16', __exports__)
  }
  
  module.hot.accept("./CommonProperty.vue?vue&type=template&id=2e9a9c16", () => {
    console.log('re-render')
    api.rerender('2e9a9c16', render)
  })

}


export default __exports__